import { Component, Input, OnInit } from '@angular/core';
import { QualificationStatus } from 'src/app/core/enums/lead/qualification-status.enum';
import { LeadStatusTransition } from 'src/app/core/models/lead/lead-status-transition.model';

@Component({
    selector: 'sidenav-content-lead-info-state-history',
    templateUrl: './sidenav-content-lead-info-state-history.component.html',
    styleUrls: ['./sidenav-content-lead-info-state-history.component.scss'],
    standalone: false
})
export class SidenavContentLeadInfoStateHistoryComponent implements OnInit {

  @Input() transitions: LeadStatusTransition[] = []

  qualificationStatus = QualificationStatus

  constructor() { }

  ngOnInit(): void {
  }

  displayedColumns = ['Processing Status', 'When', 'Time in status', 'Qualification']
}
